// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/col/index.css
// module id = 180
// module chunks = 1